import { gql } from "@apollo/client";
export const GET_PROCESS_STATUS = gql`
    query getStatus($params: ProcessRequestParams!) {
        processStatus(params: $params) {
            requestSysId
            processAutomationStates {
                states
            }
            processState {
                companySysId
                requestSysId
                state
            }
        }
    }
`;

export const GET_LATEST_STATUS = gql`
    query GetProcessHistory($processId: string) {
        processHistory(processId: $processId) {
            requestSysId
            processState
            createdOn
            lastUpdatedOn
        }
    }
`;
